"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthMessage = void 0;
const util_1 = require("../../util");
const getAuthMessage = async (address) => {
    try {
        const data = await (0, util_1.API_NODE_HANDLER)(`/api/message/${address}`, "GET");
        return { message: data[0].message, error: null };
    }
    catch (err) {
        return { message: null, error: JSON.parse(err?.message) };
    }
};
exports.getAuthMessage = getAuthMessage;
